export interface SectionConfig {
  id: string;
  title: string;
  shortTitle?: string;
}

export const reportSections: SectionConfig[] = [
  { id: 'intro', title: 'Overview', shortTitle: 'Overview' },
  { id: 'situation', title: 'Your Situation', shortTitle: 'Situation' },
  { id: 'realestate', title: 'Real Estate', shortTitle: 'RE Basics' },
  { id: 'stockmarket', title: 'Stock Market', shortTitle: 'Stocks' },
  { id: 'geography', title: 'Geography', shortTitle: 'Geography' },
  { id: 'property', title: 'The Property', shortTitle: 'Property' },
  { id: 'rent', title: 'Keep & Rent', shortTitle: 'Rent' },
  { id: 'sell', title: 'Sell & Invest', shortTitle: 'Sell' },
  { id: 'comparison', title: 'Comparison', shortTitle: 'Compare' },
  { id: 'uncertainty', title: 'Uncertainty', shortTitle: 'Uncertainty' },
  { id: 'frameworks', title: 'Frameworks', shortTitle: 'Frameworks' },
  { id: 'recommendation', title: 'Recommendation', shortTitle: 'Recommend' },
  { id: 'decision', title: 'Decision', shortTitle: 'Decision' },
  { id: 'sources', title: 'Sources', shortTitle: 'Sources' },
];

export const sectionIds = reportSections.map(s => s.id);
